import { Trans } from '@lingui/react/macro';
import { IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function AttachmentDropDown(props) {
    const { onEdit, onDelete } = props;
    const handleCallback = (callback) => () => {
        callback();
    };
    return (<Menu.Root target={<IconButton size="xs" appearance="ghost" $round>
          <Falcon icon="ellipsis-v"/>
        </IconButton>}>
      <Menu.Item onClick={handleCallback(onEdit)}>
        <Falcon icon="arrows-rotate"/>
        <Trans comment="Attachment dropdown menu replace document">Replace</Trans>
      </Menu.Item>
      <Menu.Item onClick={handleCallback(onDelete)}>
        <Falcon icon="remove"/>
        <Trans comment="Attachment dropdown menu remove document">Remove</Trans>
      </Menu.Item>
    </Menu.Root>);
}
